// extracted by mini-css-extract-plugin
export default {"globalConfigEditDialog":"globalConfigEditDialog-uBZku","title":"title-OP2vo"};